import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function CountdownCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-16 px-4 bg-brand-bg relative" data-id="element-70">
      <div className="max-w-3xl mx-auto text-center" data-id="element-71">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-[2rem] shadow-xl border-2 border-brand-rose/20" data-id="element-72">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-plum mb-8" data-id="element-73">
            Esta oferta especial con los 6 bonos gratis expira pronto:
          </h3>

          <div className="flex justify-center gap-4 md:gap-8 mb-10" data-id="element-74">
            {[{
            label: 'HORAS',
            value: timeLeft.hours
          }, {
            label: 'MINUTOS',
            value: timeLeft.minutes
          }, {
            label: 'SEGUNDOS',
            value: timeLeft.seconds
          }].map((unit, i) => <div key={i} className="flex flex-col items-center" data-id="element-75">
                <div className="bg-brand-plum text-brand-gold w-20 h-24 md:w-24 md:h-28 rounded-2xl flex items-center justify-center text-4xl md:text-5xl font-bold shadow-inner mb-2" data-id="element-76">
                  {formatNumber(unit.value)}
                </div>
                <span className="text-xs md:text-sm font-bold text-brand-textLight tracking-wider" data-id="element-77">
                  {unit.label}
                </span>
              </div>)}
          </div>

          <CTAButton text="EMPEZAR MI TRANSFORMACIÓN HOY →" data-id="element-78" />
        </motion.div>
      </div>
    </section>;
}